module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAbUlEQVQ4EaXBsQ2AAAzAsOT/o0vGDkhUwpaf5Cf5ST5MeGGIfJjwwhD5MOGFIfJhwgtD5GjCYogcTVgMkaMJiyFyNGExRI4mLIbI0YTFEDmasBgiRxMWQ+RowmKIHE1YDJGjCYshcjRhMUR+egB+VkAVXZl7IQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_01.png
// module id = 234
// module chunks = 0